import styled from 'styled-components';

export type AutoCompleteResultProps = Readonly<{
    /**
     * If the item is currently highlighted.
     */
    $isHighlighted: boolean;
}>;

const AutoCompleteResult = styled.div<AutoCompleteResultProps>`
    display: flex;
    flex-wrap: nowrap;
    padding: 0.5rem;
    gap: 1.5rem;
    align-content: center;
    align-items: center;
    cursor: pointer;
    background-color: ${({ $isHighlighted }) =>
        $isHighlighted ? 'var(--action-selected)' : 'transparent'};

    &:hover {
        background-color: var(--action-hover);
    }
`;

export { AutoCompleteResult };
